import React, { useContext, useEffect, useRef } from "react";
import "../../styles/sidebar_styles/TenantAdministratorSideBar.css";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppProvider";
const TenantAdministratorSideBar = () => {
    const navigate = useNavigate();
    const {
        showSideBar,setShowSideBar,
        mobileSideBarLauncherRef
    } = useContext(AppContext);
    const tenantAdministratorSideBarRef = useRef(null);
    const handleTenantAdministratorSideBarClick = (e) =>{
        if(mobileSideBarLauncherRef.current && !mobileSideBarLauncherRef.current.contains(e.target) &&
            tenantAdministratorSideBarRef.current && !tenantAdministratorSideBarRef.current.classList.contains('hidden')){
            setShowSideBar(false);
        }
    };
    useEffect(() => {
        document.addEventListener('click',handleTenantAdministratorSideBarClick);
    },[]); 
    useEffect(() => {
        if(!showSideBar && tenantAdministratorSideBarRef.current && !tenantAdministratorSideBarRef.current.classList.contains('hidden')){
            tenantAdministratorSideBarRef.current.classList.add('hidden')
        }
        else if(showSideBar && tenantAdministratorSideBarRef.current && tenantAdministratorSideBarRef.current.classList.contains('hidden')){
            tenantAdministratorSideBarRef.current.classList.remove('hidden')
        }
    },[showSideBar]);
    return(
        <div
            ref={tenantAdministratorSideBarRef}
            className={`tenant-administrator-side-bar ${showSideBar? 'show':''}`}>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate('/')}>
                <img src={process.env.PUBLIC_URL + '/images/home-icon.png'} alt="."/>
                <button>Home</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate('/tenants/dashboards')}>
                <img src={process.env.PUBLIC_URL + '/images/dashboards-icon.png'} alt="."/>
                <button>Dashboards</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate('/tenants/devices')}>
                <img src={`${process.env.PUBLIC_URL}/images/devices-icon.png`} alt="Devices"/>
                <button>Devices</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate('/tenants/customers')}>
                <img src={`${process.env.PUBLIC_URL}/images/customers-icon.png`} alt="."/>
                <button>Customers</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate('/tenants/inactive-devices/reports')}>
                <img src={`${process.env.PUBLIC_URL}/images/inactive-devices-report-icon.png`} alt="."/>
                <button>Inactivity reports</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate('/tenants/billing-accounts')}>
                <img src={`${process.env.PUBLIC_URL}/images/billing-account-icon.png`} alt="."/>
                <button>Billing accounts</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate("/tenants/subscription-plans")}>
                <img src={`${process.env.PUBLIC_URL}/images/subscription-plans-icon.png`} alt="."/>
                <button>Subscription plans</button>
            </div>
            <div className="tenant-administrator-side-bar-button-container" onClick={() => navigate("/tenants/invoices")}>
                <img src={`${process.env.PUBLIC_URL}/images/invoices-icon.png`} alt="."/>
                <button>Invoices</button>
            </div>
        </div>
    );
}
export default TenantAdministratorSideBar;